import { useState } from 'react';


const SentenceCounters = () => {
  const [text, setText] = useState('');
  const [sentenceCount, setSentenceCount] = useState(0);
  const [wordCount, setWordCount] = useState(0);
  const [characterCount, setCharacterCount] = useState(0);


  const handleTextChange = (e) => {
    const text = e.target.value;
    setText(text);
    setSentenceCount(text.split('.').filter(sentence => sentence.trim() !== '').length);
    setWordCount(text.split(' ').filter(word => word.trim() !== '').length);
    setCharacterCount(text.length);
  };


  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label

  const handleCopyClick = () => {
    navigator.clipboard.writeText(text);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };

   // Clear input fields
   const clearFields = () => {
    setText('');
    setSentenceCount('');
    setWordCount('');
    setCharacterCount('');
  };


  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">

    <div className="card-body">
     
      <textarea
        className="form-control mb-4"
        value={text}
        onChange={handleTextChange}
        placeholder="Enter your text here..."
        rows={5}
      />
      <div className="row mb-4">
        <div className="col-md-4 mb-4">
          <h2 className="h5">Sentences:</h2>
          <p className="display-4">{sentenceCount}</p>
        </div>
        <div className="col-md-4 mb-4">
          <h2 className="h5">Words:</h2>
          <p className="display-4">{wordCount}</p>
        </div>
        <div className="col-md-4 mb-4">
          <h2 className="h5">Characters:</h2>
          <p className="display-4">{characterCount}</p>
        </div>
      </div>
      <button
            className="btn btn-primary mt-3"
            onClick={handleCopyClick}
      >
       {copyButtonLabel}
      </button>
      <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
    </div>
 
</div>

  );
};

export default SentenceCounters;